
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "id": "Layer_1_1_",
    "style": "enable-background:new 0 0 64 64;",
    "version": "1.1",
    "viewBox": "0 0 64 64",
    "xml:space": "preserve",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "g",
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M28,1h-4.106C15.068,1,6.937,6.16,3.179,14.146C1.753,17.175,1,20.547,1,23.895v16.211c0,3.348,0.753,6.72,2.179,9.749   C6.937,57.84,15.068,63,23.894,63H28c1.654,0,3-1.346,3-3V46.64c0-1.426-1.015-2.663-2.412-2.941l-10.177-2.035   C17.014,41.384,16,40.146,16,38.721V25.279c0-1.426,1.014-2.663,2.412-2.942l10.176-2.035C29.985,20.023,31,18.786,31,17.36V4   C31,2.346,29.654,1,28,1z M29,46.64V60c0,0.552-0.449,1-1,1h-3V45.02l3.196,0.639C28.662,45.752,29,46.164,29,46.64z    M18.019,20.376C15.69,20.842,14,22.904,14,25.279v13.441c0,2.375,1.69,4.438,4.019,4.903L23,44.62v16.347   C15.295,60.633,8.291,56.02,4.989,49.003C3.688,46.238,3,43.161,3,40.105V23.895c0-3.056,0.688-6.133,1.989-8.897   C8.291,7.98,15.295,3.367,23,3.033V19.38L18.019,20.376z M29,17.36c0,0.476-0.338,0.888-0.804,0.98L25,18.98V3h3   c0.551,0,1,0.448,1,1V17.36z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M18.725,5.729c-5.262,1.508-9.609,5.196-11.926,10.119c-0.433,0.92-0.794,1.889-1.075,2.88l1.924,0.545   c0.251-0.887,0.575-1.752,0.961-2.573C10.68,12.298,14.568,9,19.275,7.65L18.725,5.729z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M5.033,22.785l1.996,0.119c0.038-0.637,0.114-1.279,0.225-1.912l-1.97-0.346C5.16,21.354,5.076,22.073,5.033,22.785z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M58,1H38c-2.757,0-5,2.243-5,5v8c0,2.757,2.243,5,5,5h20c2.757,0,5-2.243,5-5V6C63,3.243,60.757,1,58,1z M61,14   c0,1.654-1.346,3-3,3H38c-1.654,0-3-1.346-3-3V6c0-1.654,1.346-3,3-3h20c1.654,0,3,1.346,3,3V14z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M47.213,34.316l2.514-0.838C51.086,33.025,52,31.758,52,30.324C52,28.491,50.508,27,48.675,27h-1.351   C45.492,27,44,28.491,44,30.324V31h2v-0.676C46,29.594,46.594,29,47.325,29h1.351C49.406,29,50,29.594,50,30.324   c0,0.571-0.364,1.077-0.905,1.257l-2.514,0.838C45.037,32.934,44,34.373,44,36v1h8v-2h-5.692   C46.521,34.687,46.835,34.442,47.213,34.316z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M58,45H38c-2.757,0-5,2.243-5,5v8c0,2.757,2.243,5,5,5h20c2.757,0,5-2.243,5-5v-8C63,47.243,60.757,45,58,45z M61,58   c0,1.654-1.346,3-3,3H38c-1.654,0-3-1.346-3-3v-8c0-1.654,1.346-3,3-3h20c1.654,0,3,1.346,3,3V58z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M58,23H38c-2.757,0-5,2.243-5,5v8c0,2.757,2.243,5,5,5h20c2.757,0,5-2.243,5-5v-8C63,25.243,60.757,23,58,23z M61,36   c0,1.654-1.346,3-3,3H38c-1.654,0-3-1.346-3-3v-8c0-1.654,1.346-3,3-3h20c1.654,0,3,1.346,3,3V36z"
          }
        },
        {
          "tag": "polygon",
          "attrsMap": {
            "points": "49,5 46.586,5 44.293,7.293 45.707,8.707 47,7.414 47,13 45,13 45,15 51,15 51,13 49,13  "
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M49,49h-5v2h5c0.551,0,1,0.448,1,1s-0.449,1-1,1h-3v2h3c0.551,0,1,0.448,1,1s-0.449,1-1,1h-5v2h5c1.654,0,3-1.346,3-3   c0-0.768-0.29-1.469-0.766-2C51.71,53.469,52,52.768,52,52C52,50.346,50.654,49,49,49z"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "53",
            "y": "9"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "57",
            "y": "9"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "37",
            "y": "9"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "41",
            "y": "9"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "53",
            "y": "31"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "57",
            "y": "31"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "37",
            "y": "31"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "41",
            "y": "31"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "53",
            "y": "53"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "57",
            "y": "53"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "37",
            "y": "53"
          }
        },
        {
          "tag": "rect",
          "attrsMap": {
            "height": "2",
            "width": "2",
            "x": "41",
            "y": "53"
          }
        }
      ]
    }
  ]
})
    }
  